import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  DialogContent,
  Dialog,
  DialogTitle,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { useNeedsReview } from "../hooks/logic/useNeedsReview";
import { isNotGeneralUser } from "../constants/roles";
import { NeedsReviewStyle as styles } from "./NeedsReviewStyle";
import SearchByGenre from "../components/SearchByGenre";
import UserFilterSelect from "../components/UserFilter";
import StatusSelect from "../components/StatusSelect";
import PendingReceiptTable, {
  PendingReceiptItem,
} from "../components/pendingReceipt/PendingReceiptTable";
import ProductInfoDialog from "../components/ProductInfoDialog";
import { useRecoilValue } from "recoil";
import { statusListSelector } from "../recoil/selectors/statusListSelector";
import ConfirmDialog from "../components/ConfirmDialog";
import PendingPackagingTable from "../components/pendingPackaging/PendingPackagingTable";
import JanCodeCheckDialog from "../components/JanCodeCheckDialog";
import NeedsReviewTable from "../components/Table/NeedsReviewTable";

const NeedsReview = () => {
  const {
    inputRef,
    loginUser,
    needsReviewList,
    userOptions,
    selectedUserId,
    handleUserChange,
    checkedIds,
    handleCheckChange,
    searchGenres,
    selectedGenreId,
    setSelectedGenreId,
    focusInputField,
    handleGenreChange,
    searchKeyword,
    setSearchKeyword,
    searchItems,
    resetFilter,
    resetGenreWord,
    handleKeywordChange,
    expectedCount,
    handleRowClick,
    selectedStatusId,
    handleStatusChange,
    detailDialogOpen,
    setDetailDialogOpen,
    selectedParent,
    setSelectedParent,
    selectedChildren,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    resetCheckCode,
    janDialogOpen,
    setJanDialogOpen,
    checjkJanItem,
    imageUrl,
    handleExpiryDatePrintAllAtOnce,
    handlePrintAllAtOnce,
    handlePageChange,
    totalListCount,
    changeSortKey,
  } = useNeedsReview();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ProductInfoDialog
        open={detailDialogOpen}
        onClose={() => {
          setSelectedParent(null);
          selectedChildren.current = [];
          setDetailDialogOpen(false);
        }}
        title="商品情報"
        parentItem={selectedParent!}
        childItems={selectedChildren.current}
        statusId={selectedParent?.statusId ?? 0}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          要確認
        </Typography>
      </Box>
      <Box py={0} px={0}>
        <Box
          display="flex"
          // gap={2}
          // mb={2}
          // flexWrap="wrap"
          // alignItems="center"
          px={1}
          justifyContent="space-between"
        >
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" gap={2} flexWrap="wrap" alignItems="flex-start">
              {isNotGeneralUser(loginUser?.permissionId) && (
                <UserFilterSelect
                  options={userOptions}
                  onSelect={handleUserChange}
                  value={selectedUserId}
                  sx={{ width: "300px" }}
                />
              )}
              <Button
                variant="outlined"
                onClick={async () => {
                  await resetFilter();
                  resetCheckCode();
                }}
              >
                フィルター解除
              </Button>
            </Box>
            <Box display="flex" gap={2} mb={2} flexWrap="wrap">
              <SearchByGenre
                options={["JAN", "ASIN", "商品名", "FNSKU", "SKU"]}
                defaultGenre="JAN"
                onGenreChange={handleGenreChange}
                searchKeyword={searchKeyword}
                onKeywordChange={setSearchKeyword}
                onEnter={focusInputField}
              />

              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  searchItems(searchKeyword);
                }}
              >
                検索
              </Button>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-start"
            gap={4}
            mb={2}
          ></Box>
        </Box>

        <Box mt={2}>
          <NeedsReviewTable
            data={needsReviewList}
            totalListCount={totalListCount}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onParentRowClick={handleRowClick}
            handleExpiryDatePrintAllAtOnce={handleExpiryDatePrintAllAtOnce}
            handlePrintAllAtOnce={handlePrintAllAtOnce}
            onPageChange={handlePageChange}
            onSortChange={(key, ord) => {
              changeSortKey(key, ord);
            }}
          ></NeedsReviewTable>
        </Box>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default NeedsReview;
